import { GotoLogoComponent, gotoLogoTemplate } from './GotoLogo';
import styles from './GotoLogo.styles.scss';
export const gotoLogoDefinition = {
    baseName: 'goto-logo',
    template: gotoLogoTemplate,
    styles,
};
export const chameleonGotoLogo = GotoLogoComponent.compose(gotoLogoDefinition);
